import { watch } from 'vue'

import { useKidStore } from '@entities/customer'

import { useUpsellBannerApi } from './upsell-banner.hook'

export const useUpsellBannerLoad = (): void => {
  const kidStore = useKidStore()
  const { fetchUpsellBanner } = useUpsellBannerApi()

  watch(() => kidStore.activeKidId, (kidId) => {
    if (typeof kidId !== 'number') return

    void fetchUpsellBanner()
  }, { immediate: true })
}
